import React from 'react';
import { Star, Quote } from 'lucide-react';
import { guestbookEntries } from '@/data/mock';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export const TestimonialsSection = () => {
  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <Star
        key={i}
        className={`w-4 h-4 ${
          i < rating ? 'fill-[var(--color-gold)] text-[var(--color-gold)]' : 'text-[var(--color-beige)]'
        }`}
      />
    ));
  };

  return (
    <section className="py-24 bg-[var(--surface-cream)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-sm uppercase tracking-wider text-[var(--color-gold)] font-medium mb-4">
            Témoignages
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[var(--text-primary)] mb-6">
            Ce que disent nos familles
          </h2>
          <div className="w-24 h-px bg-[var(--color-gold)] mx-auto"></div>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {guestbookEntries.map((entry) => (
            <div key={entry.id} className="testimonial-card hover-lift">
              <Quote className="w-10 h-10 text-[var(--color-gold)] opacity-30 mb-4" />
              <p className="text-[var(--text-secondary)] leading-relaxed mb-6">
                "{entry.message}"
              </p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-medium text-[var(--text-primary)]">
                    {entry.name}
                  </p>
                  <p className="text-sm text-[var(--text-subtle)]">
                    {new Date(entry.date).toLocaleDateString('fr-FR', {
                      year: 'numeric',
                      month: 'long'
                    })}
                  </p>
                </div>
                <div className="flex gap-0.5">
                  {renderStars(entry.rating)}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link to="/livre-dor">
            <Button variant="outline" className="btn-outline">
              Voir tous les avis
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};
